import { Pipe, PipeTransform } from '@angular/core';
import { CardModel, JobPartModel } from 'src/app/models';

@Pipe({ name: 'toJobPartCards' })
export class JobPartCardsPipe implements PipeTransform {
  transform(values: JobPartModel[]): CardModel[] {
    return values?.map((job) => CardModel.fromJobPartModel(job));
  }
}
